import React, { useEffect, useState } from "react";
import { Form, Row, Col, Button, Container, FloatingLabel } from "react-bootstrap";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const API_URL = process.env.REACT_APP_API_URL;

function Literature_Avenue() {
    const [comment, setComment] = useState("");
    const [literature, setLiterature] = useState("");
    const { user: loggedUser } = useAuth();
    const navigate = useNavigate();

    const [successMsg, setSuccessMsg] = useState("");
    const [errorMsg, setErrorMsg] = useState("");

    const [documents, setDocuments] = useState([
        { id: Date.now(), research_point: "", reference_link: "" },
        // { id: Date.now() + 1, research_point: "", reference_link: "" },
        // { id: Date.now() + 2, research_point: "", reference_link: "" }
    ]);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const [literatures, setLiteratures] = useState([]);

    useEffect(() => {
        const token = localStorage.getItem("token");
        if (!token) return;

        axios.get(`${API_URL}/literature_types_list`, {
            headers: { Authorization: `Bearer ${token}` }
        })
            .then((res) => setLiteratures(res.data.literatures || []))
            .catch((err) => console.error(err));
    }, []);

    const addRow = () => {
        setDocuments([
            ...documents,
            { id: Date.now(), research_point: "", reference_link: "" }
        ]);
    };

    // const removeRow = (id) => {
    //     if (documents.length === 0) return;
    //     setDocuments(documents.filter((doc) => doc.id !== id));
    // };
    const removeRow = (id) => {
        if (documents.length === 0) return;

        const confirmDelete = window.confirm("Do you want to delete?");

        if (confirmDelete) {
            setDocuments(documents.filter((doc) => doc.id !== id));
        }
    };

    const handleChange = (id, field, value) => {
        setDocuments((docs) =>
            docs.map((doc) =>
                doc.id === id ? { ...doc, [field]: value } : doc
            )
        );
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (isSubmitting) return;

        setIsSubmitting(true);
        if (!literature) {
            alert("Please select literature name!");
            return;
        }

        if (documents.some(doc => !doc.research_point || !doc.reference_link)) {
            alert("Please fill all table fields!");
            return;
        }

        try {
            const payload = {
                literature,
                comment,
                center_name: loggedUser?.center,
                documents: documents
            };

            const response = await axios.post(
                `${API_URL}/add_literature_avenue`,
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("token")}`
                    }
                }
            );

            // alert(response.data.message);
            // navigate("/Literature_Avenue_List");

            setSuccessMsg(response.data.message || "Add successfully");
            setErrorMsg("");

            setTimeout(() => {
                navigate("/Literature_Avenue_List");
            }, 1000);


            setLiterature("");
            setComment("");
            setDocuments([
                { id: Date.now(), research_point: "", reference_link: "" }
            ]);

        } catch (error) {
            console.error(error);

            setErrorMsg("Update failed");

            setTimeout(() => setErrorMsg(""), 1000);
            // alert("Error adding literature data!");
        }
        finally {
            setIsSubmitting(false);

        }
    };

    return (
        <Container className="mt-4">
            {successMsg && (
                <div className="alert alert-success mt-2">
                    {successMsg}
                </div>
            )}

            {errorMsg && (
                <div className="alert alert-danger mt-2">
                    {errorMsg}
                </div>
            )}

            <div className="d-flex flex-wrap justify-content-between align-items-center mb-3">
                <h3>Literature Avenue</h3>
                <Link className="btn btn-primary btn-sm mt-2 mt-md-0" to="/Literature_Avenue_List">
                    List
                </Link>
            </div>

            <Form autoComplete="off" onSubmit={handleSubmit}>
                <Row className="mt-3">
                    <Col xs={12} className="mb-3">
                        <Form.Label className="fw-semibold">Literature Theme</Form.Label>
                        <Form.Select
                            value={literature}
                            onChange={(e) => setLiterature(e.target.value)}
                            required >
                            <option value="">-- Select Literature --</option>
                            {literatures.map((item) => (
                                <option key={item.literature_id} value={item.literature_id}>
                                    {item.literature_name}
                                </option>
                            ))}
                        </Form.Select>
                    </Col>
                </Row>

                <Row>
                    <Col xs={12}>
                        <div className="table-responsive">
                            <table className="table table-bordered table-striped">
                                <thead style={{ backgroundColor: "#e6ffff" }}>
                                    <tr>
                                        <th>Sr.No</th>
                                        <th>Research Evidence Points</th>
                                        <th>Reference Link</th>
                                        <th className="text-center">
                                            <Button variant="success" size="sm" onClick={addRow}>
                                                + Add
                                            </Button>
                                        </th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {documents.map((doc, index) => (
                                        <tr key={doc.id}>
                                            <td>{index + 1}</td>

                                            <td>
                                                <Form.Control
                                                    as="textarea"
                                                    placeholder="Enter research point" rows={3}
                                                    value={doc.research_point} required
                                                    onChange={(e) =>
                                                        handleChange(doc.id, "research_point", e.target.value)
                                                    }
                                                />
                                            </td>

                                            <td>
                                                <Form.Control
                                                    as="textarea"
                                                    placeholder="Reference link"
                                                    value={doc.reference_link} required rows={3}
                                                    onChange={(e) =>
                                                        handleChange(doc.id, "reference_link", e.target.value)
                                                    }
                                                />
                                            </td>

                                            <td className="text-center">
                                                <Button
                                                    variant="danger"
                                                    size="sm"
                                                    onClick={() => removeRow(doc.id)}
                                                >
                                                    Delete
                                                </Button>
                                            </td>
                                        </tr>

                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </Col>
                </Row>

                <Row className="mt-4">
                    <Col xs={12}>
                        <FloatingLabel label="Enter Comments">
                            <Form.Control
                                as="textarea"
                                style={{ height: "80px" }}
                                value={comment}
                                onChange={(e) => setComment(e.target.value)}
                            />
                        </FloatingLabel>
                    </Col>
                </Row>

                <Row className="mt-4">
                    <Col className="text-center"> 
                        <Button type="submit" variant="primary" disabled={isSubmitting}>
                            {isSubmitting ? "Submitting..." : "Submit"} 
                        </Button>
                    </Col>
                </Row>
            </Form>
        </Container>
    );
}

export default Literature_Avenue;
